import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import './Header.scss';
import { bannerObj } from '../../common/consts';
import { bannerDetails } from '../../reducer/BannerInfo';
import { bannerNameValueFunc, isImzFlowType } from '../../common/utils';
import prescriptionBanner from '../../common/images/prescriptionBanner.png';
import immunizationBanner from '../../common/images/immunizationBanner.png';
import DesktopImmunizationBanner from '../../common/images/DesktopImmunizationBanner.jpg';
import DesktopRxBanner from '../../common/images/DesktopRxBanner.jpg';

const Header = () => {
  const [logoURL, setLogoURL] = useState('');
  const [logoLink, setLogoLink] = useState('');
  const [logoName, setlogoName] = useState('');
  const dispatch = useDispatch();
  const [logoPathFlag, setLogoPathFlag] = useState(false);

  useEffect(() => {
    const bannerNameValue = bannerNameValueFunc();
    if (bannerNameValue) {
      bannerMapContent(bannerNameValue);
    }
  }, [logoPathFlag]);

  const bannerMapContent = (bannerNameContent) => {
    bannerObj.forEach((item) => {
      if (item.bannerName === bannerNameContent) {
        setLogoPathLink(item);
        setLogoPathFlag(true);
      }
    });
  };

  const setLogoPathLink = (itemVal) => {
    // eslint-disable-next-line global-require
    const logoPath = require(`../../common/images/Logo/${itemVal.logo}`);
    // eslint-disable-next-line global-require
    const iconPath = require(`../../common/images/Logo/Favicon/${itemVal.favIcon}`);
    const favicon = document.getElementById('favicon');
    if (favicon !== null) {
      favicon.href = iconPath;
    }

    setLogoURL(logoPath);
    const commonURLPrefix = `${
      process.env.REACT_APP_SHORT_REG_URL_PREFIX
    }.${bannerNameValueFunc()}`;
    const udateLogoLink = `${commonURLPrefix}.com/account/short-registration.html`;
    const updatedPharmacyLink = `${commonURLPrefix}.com/pharmacy.html`;
    const updatedHomePageLink = `${commonURLPrefix}.com/`;
    itemVal.homePageLink = updatedHomePageLink;
    itemVal.pharmacyLink = updatedPharmacyLink;
    setLogoLink(itemVal.pharmacyLink);
    setlogoName(itemVal.heroText);
    itemVal.logoLink = udateLogoLink;
    dispatch(bannerDetails(itemVal));
  };

  return (
    <div>
      <header className="header-wrapper">
        <div className="logo">
          <a href={logoLink} target="_blank" className="GA4_CTA">
            <img src={logoURL} alt={`${logoName} logo`} />
          </a>
        </div>
      </header>
      <div className="incentive-banner">
        {isImzFlowType ? (
          <>
            {' '}
            <img
              src={immunizationBanner}
              className="incentive-banner-img"
              alt=""
            />
            <img
              src={DesktopImmunizationBanner}
              className="incentive-banner-img-desktop"
              alt=""
            />
          </>
        ) : (
          <>
            <img
              src={prescriptionBanner}
              className="incentive-banner-img"
              alt=""
            />
            <img
              src={DesktopRxBanner}
              className="incentive-banner-img-desktop"
              alt=""
            />
          </>
        )}
      </div>
    </div>
  );
};
export default Header;
